import React from "react";

import provisionalModuleDataBasedOnLanguage from "../../searchList/provisionalModuleDataBasedOnLanguage";


export default function supplierTopBar({onEditSearch, arrivalDate, departureDate, guests, selectedLanguage, type, buttonStyles = {}, name = "", rooms = false }) {
  const format = new Intl.DateTimeFormat(selectedLanguage, {
    month: 'short', day: 'numeric',
  })
  const temporalTranslations = provisionalModuleDataBasedOnLanguage(selectedLanguage);

  const formText = () => {
    if ((type === "activity" || type === "activities" || type === "restaurant" || type === "restaurants") && arrivalDate) {
      return  <div className="flex flex-col gap-1">
        {name ? name : null}
        <span>{arrivalDate ? format.format(arrivalDate) : null}</span>
      </div>
    }
    if ((type === "lodging" || type === "room" || type === "unit" || type === "cabin" || type === "hotel") && arrivalDate && departureDate && guests) {
      return (
        <div className="flex flex-col gap-1">
          { name ? name : null}
          <div>
            <span className="border-r pr-2">{arrivalDate ? format.format(arrivalDate) : null} - {departureDate ? format.format(departureDate) : null}</span>
            <span className="pl-2">{guests} {guests > 1 ? temporalTranslations.guestsLabel : temporalTranslations.guestLabel}</span>
            {rooms > 1 ? <span className="ml-2 pl-2 border-l">{`(${rooms} ${temporalTranslations.rooms})`}</span> : null }
          </div>
        </div>
      )
    }
    return temporalTranslations[`fill_${type === "unit" || type === "room" || type === "cabin" || type === "hotel" || type === "lodging" ? "lodging" : "activities"}`]
  }

  return <div id="mobileToast" className="py-4 bg-white flex flex-row justify-between items-center font-semibold w-full lg:w-auto lg:p-0 gap-4 text-sm">
    <div id="mobileCurrentSearch" className={"flex"}>
      {formText()}
    </div>
    <button className="p-2 rounded-lg bg-white border-2 border-[color:var(--secondaryColor)] text-[color:var(--primaryColor)] ml-auto lg:m-0 whitespace-nowrap" onClick={() => onEditSearch()}>
      {temporalTranslations.editSearch}
    </button>
  </div>
}